module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入发行游戏名称"
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.issued_app_base_id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "fixed": "",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "小游戏名称",
      "min-width": "50px",
      "align": "center",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "fixed": "",
      "label": "功能点",
      "min-width": "50px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rule), function(value, key) {
          return _c('span', _vm._l((value), function(val, k, i) {
            return (k == 'rule') ? _c('span', _vm._l((val), function(cit, cid) {
              return _c('span', {
                staticClass: "gn",
                on: {
                  "mousemove": function($event) {
                    return _vm.showGN($event, scope.row, cid, key)
                  },
                  "mouseleave": function($event) {
                    return _vm.hideGN($event, scope.row, i, key)
                  }
                }
              }, [_vm._v(_vm._s(cit.name) + ",")])
            }), 0) : _vm._e()
          }), 0)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand",
      "label": "SDK配置",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "版本"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.review_ver))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "路径"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.path))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "屏蔽城市"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.valid_ad_city))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "场景值"
          }
        }, [(props.row.valid_ad_scene_white != '') ? _c('span', [_vm._v("白名单：" + _vm._s(props.row.valid_ad_scene_white))]) : _c('span', [_vm._v("黑名单：" + _vm._s(props.row.valid_ad_scene_black))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "激活状态",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "fixed": "",
      "label": "操作",
      "min-width": "50px",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRule(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '产品日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'shieldRule'
                }
              })
            }
          }
        }, [_vm._v("更新日志")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.gnTxt.show) ? _c('div', {
    staticClass: "el-popover el-popper",
    staticStyle: {
      "width": "400px",
      "position": "fixed",
      "transform-origin": "center top",
      "z-index": "2003"
    },
    style: ({
      top: _vm.gnTxt.top + 'px',
      left: _vm.gnTxt.left + 'px'
    }),
    attrs: {
      "role": "tooltip",
      "id": "el-popover-2968",
      "aria-hidden": "false",
      "tabindex": "0",
      "x-placement": "bottom-start"
    }
  }, [(_vm.gnTxt.no) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("序号")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.no) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.no))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.city) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽城市")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.city) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.city))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_black && _vm.gnTxt.scene_white == '') ? _c('div', [(_vm.gnTxt.scene_black && _vm.gnTxt.scene_white == '') ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽黑名单")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_black != '') ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.scene_black))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_white) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽白名单")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.scene_white) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.scene_white))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.path_black) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽路径")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.path_black) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.path_black))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_num) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽次数")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_num) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.show_num))]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_per) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("屏蔽概率")]) : _vm._e(), _vm._v(" "), (_vm.gnTxt.show_per) ? _c('p', [_vm._v(_vm._s(_vm.gnTxt.show_per))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popper__arrow",
    staticStyle: {
      "left": "8px"
    },
    attrs: {
      "x-arrow": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '添加屏蔽规则' : '编辑屏蔽规则',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "1100px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "小程序选择",
      "prop": "请输入小程序名称"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请输入小程序名称"
    },
    model: {
      value: (_vm.issued_app_id),
      callback: function($$v) {
        _vm.issued_app_id = $$v
      },
      expression: "issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item) {
    return _c('el-option', {
      key: item.issued_app_base_id,
      attrs: {
        "label": item.name,
        "value": item.issued_app_base_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, _vm._l((_vm.chooseProduct), function(value, key, idx) {
    return _c('el-tab-pane', {
      attrs: {
        "label": key
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "APPID"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": '请输入' + key + '平台的APPID'
      },
      on: {
        "input": function($event) {
          return _vm.inputCG('appid', value.appid, key, idx)
        }
      },
      model: {
        value: (value.appid),
        callback: function($$v) {
          _vm.$set(value, "appid", $$v)
        },
        expression: "value.appid"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "SDK配置"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "审核版本号"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.review_ver),
        callback: function($$v) {
          _vm.$set(value.sdk, "review_ver", $$v)
        },
        expression: "value.sdk.review_ver"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "路径"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.path),
        callback: function($$v) {
          _vm.$set(value.sdk, "path", $$v)
        },
        expression: "value.sdk.path"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "屏蔽城市"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.valid_ad_city),
        callback: function($$v) {
          _vm.$set(value.sdk, "valid_ad_city", $$v)
        },
        expression: "value.sdk.valid_ad_city"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [(value.sdk.isWhite) ? _c('el-input', {
      attrs: {
        "placeholder": "白名单"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.valid_ad_scene_white),
        callback: function($$v) {
          _vm.$set(value.sdk, "valid_ad_scene_white", $$v)
        },
        expression: "value.sdk.valid_ad_scene_white"
      }
    }) : _c('el-input', {
      attrs: {
        "placeholder": "黑名单"
      },
      on: {
        "input": function($event) {
          return _vm.inputCG()
        }
      },
      model: {
        value: (value.sdk.valid_ad_scene_black),
        callback: function($$v) {
          _vm.$set(value.sdk, "valid_ad_scene_black", $$v)
        },
        expression: "value.sdk.valid_ad_scene_black"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-checkbox', {
      attrs: {
        "checked": value.sdk.isWhite
      },
      on: {
        "change": function($event) {
          return _vm.valid_adWhiteChange(value, idx, key)
        }
      },
      model: {
        value: (value.sdk.isWhite),
        callback: function($$v) {
          _vm.$set(value.sdk, "isWhite", $$v)
        },
        expression: "value.sdk.isWhite"
      }
    }, [_vm._v("白名单")])], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 5
      }
    })], 1), _vm._v(" "), _vm._l((value.rule), function(item, index) {
      return _c('el-form-item', {
        attrs: {
          "label": "屏蔽规则",
          "prop": "rule"
        }
      }, [_c('el-row', {
        staticStyle: {
          "margin": "0"
        },
        attrs: {
          "gutter": 5
        }
      }, [_c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('el-switch', {
        attrs: {
          "active-color": "#13ce66",
          "inactive-color": "#f2f2f2"
        },
        on: {
          "change": function($event) {
            return _vm.statusChange(index)
          }
        },
        model: {
          value: (item.status),
          callback: function($$v) {
            _vm.$set(item, "status", $$v)
          },
          expression: "item.status"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple-light"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "序号"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.no),
          callback: function($$v) {
            _vm.$set(item, "no", $$v)
          },
          expression: "item.no"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "规则名称"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.name),
          callback: function($$v) {
            _vm.$set(item, "name", $$v)
          },
          expression: "item.name"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple-light"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "屏蔽城市"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.city),
          callback: function($$v) {
            _vm.$set(item, "city", $$v)
          },
          expression: "item.city"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }), _vm._v(" "), (item.isWhite) ? _c('el-input', {
        attrs: {
          "placeholder": "白名单"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.scene_white),
          callback: function($$v) {
            _vm.$set(item, "scene_white", $$v)
          },
          expression: "item.scene_white"
        }
      }) : _c('el-input', {
        attrs: {
          "placeholder": "黑名单"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.scene_black),
          callback: function($$v) {
            _vm.$set(item, "scene_black", $$v)
          },
          expression: "item.scene_black"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('el-checkbox', {
        attrs: {
          "checked": item.isWhite
        },
        on: {
          "change": function($event) {
            return _vm.whiteChange(value, index, key)
          }
        },
        model: {
          value: (item.isWhite),
          callback: function($$v) {
            _vm.$set(item, "isWhite", $$v)
          },
          expression: "item.isWhite"
        }
      }, [_vm._v("白名单")])], 1)], 1), _vm._v(" "), _c('el-row', {
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "gutter": 5
        }
      }, [_c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "路径"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.path_black),
          callback: function($$v) {
            _vm.$set(item, "path_black", $$v)
          },
          expression: "item.path_black"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "次数"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.show_num),
          callback: function($$v) {
            _vm.$set(item, "show_num", $$v)
          },
          expression: "item.show_num"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple"
      }, [_c('el-input', {
        attrs: {
          "placeholder": "概率"
        },
        on: {
          "input": function($event) {
            return _vm.inputCG()
          }
        },
        model: {
          value: (item.show_per),
          callback: function($$v) {
            _vm.$set(item, "show_per", $$v)
          },
          expression: "item.show_per"
        }
      })], 1)]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 2
        }
      }, [_c('div', {
        staticClass: "grid-content bg-purple-light",
        staticStyle: {
          "font-size": "24px",
          "cursor": "pointer"
        }
      }, [_c('i', {
        staticClass: "el-icon-circle-plus",
        on: {
          "click": function($event) {
            return _vm.addRules(index, key)
          }
        }
      }), _vm._v(" "), (value.rule.length > 1) ? _c('i', {
        staticClass: "el-icon-remove",
        on: {
          "click": function($event) {
            return _vm.removeRules(value, index, key)
          }
        }
      }) : _vm._e()])])], 1)], 1)
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52efe1ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rules/Rlist.vue
// module id = 1104
// module chunks = 2